import { LoginProjectConfiguration } from '../api';
import { SHADOW_PROJECT_TYPE } from '../constants';

/**
 * Passkeys are configured per Login project. Shadow projects share the master
 * project's user database and do not expose their own authentication settings,
 * so the passkey card and tab are hidden for them.
 *
 * Every other rule — in particular "passkey can never be the only login method"
 * — is enforced by the backend (LOGIN-8957), which checks it on project update,
 * on social provider removal and on custom identity provider removal. The UI
 * deliberately does not duplicate that check: it cannot see cross social
 * connections or enterprise connections, so a client-side guess would block
 * publishers the backend would have allowed.
 */
export const isPasskeyAvailable = (project?: LoginProjectConfiguration | null): boolean =>
  !!project && project.type !== SHADOW_PROJECT_TYPE;
